module.exports = __webpack_public_path__ + "img/cloth_g3_pants-08.0330d141.svg";